import React from "react";
import { dialog } from "../../nq-component";
import Filter from "../Filter/Filter";
import classNames from "../../classNames";

let timeout;

function PortalSearch({
  className,
  schemas,
  fields,
  onSubmit,
  placeholder,
  onChange,
  onInput,
  redirectOnInput,
  value,
}) {
  // Handle input changes
  const handleInputChange = (event) => {
    // Call existing onChange if provided
    if (onChange) {
      onChange(event);
    }
  };

  // Handle search button click with redirect functionality
  const handleSearchClick = () => {
    const inputElement = document.querySelector('input[type="search"]');
    const inputValue = inputElement ? inputElement.value : "";

    // Handle redirect functionality for landing page
    if (redirectOnInput && onInput && inputValue.trim()) {
      onInput(inputValue);
    } else if (onSubmit) {
      // Call existing onSubmit if provided
      onSubmit();
    }
  };

  return (
    <div
      className={classNames("search-bar-container", className)}
      style={{ position: "relative" }}
    >
      <i
        className="bi bi-search"
        style={{
          position: "absolute",
          left: "15px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "#A0A0A0",
          fontSize: "1.2rem",
        }}
      />
      <input
        onChange={handleInputChange}
        value={value}
        type="search"
        className="form-control"
        placeholder={placeholder}
        style={{
          width: "100%",
          height: "4rem",
          borderRadius: "4rem",
          paddingLeft: "45px",
          paddingRight: "70px",
          border: "1px solid #E0E0E0",
          backgroundColor: "#FFFFFF",
          outline: "none",
          fontSize: "1rem",
        }}
      />

      <button
        className="search-btn"
        onClick={handleSearchClick}
        style={{
          position: "absolute",
          right: "5px",
          top: "50%",
          transform: "translateY(-50%)",
          background: "none",
          border: "none",
          color: "#D18237",
          fontWeight: "bold",
          cursor: "pointer",
          fontSize: "1rem",
        }}
      >
        Search
      </button>
    </div>
  );
}

export default PortalSearch;
